// Scroll to top on route change, unless navigating to a hash
exports.shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
	// If there's a hash, scroll to that element
	if (location.hash) {
		const element = document.querySelector(location.hash);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
		return false;
	}

	// For non-hash navigation, scroll to top
	return [0, 0];
};
